export default function AssetPlatform() {
  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-0 rounded-3xl overflow-hidden shadow-2xl">
          <div className="relative bg-[#F9E5D8] p-12 lg:p-16 flex flex-col justify-between min-h-[600px]">
            <div className="absolute inset-0 opacity-10">
              <img 
                src="https://public.readdy.ai/ai/img_res/de49956860139519f7b353a50b2a2538.jpg" 
                alt="Asset Platform Background" 
                className="w-full h-full object-cover object-center"
              />
            </div>
            
            <div className="relative z-10">
              <div className="text-xs text-gray-600 font-semibold tracking-wide mb-4">
                FEATURED SERVICE
              </div>
            </div>

            <div className="relative z-10 space-y-2">
              <div className="text-7xl lg:text-8xl font-bold text-gray-900 leading-none">
                Asset
              </div>
              <div className="text-5xl lg:text-6xl font-bold text-gray-900 leading-none">
                Sales
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-gray-700 leading-none">
                Platform
              </div>
            </div>
          </div>

          <div className="bg-white p-12 lg:p-16 flex flex-col justify-center">
            <div className="space-y-8">
              <h3 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
                Connect Buyers<br />
                to Sellers
              </h3>

              <div className="space-y-6">
                <p className="text-gray-700 text-base leading-relaxed">
                  Our innovative asset sales platform bridges the gap between buyers and sellers across Africa. Whether you're looking to purchase a new vehicle, sell a used car, or trade other valuable assets, we provide a secure and efficient marketplace.
                </p>

                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 rounded-full flex-shrink-0">
                      <i className="ri-car-line text-xl text-[#D4AF37]"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900 mb-1">Vehicle Sales</div>
                      <div className="text-sm text-gray-600">New and used vehicles with verified listings</div>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 rounded-full flex-shrink-0">
                      <i className="ri-shield-check-line text-xl text-[#D4AF37]"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900 mb-1">Secure Transactions</div>
                      <div className="text-sm text-gray-600">Protected buyer-seller connections</div>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 rounded-full flex-shrink-0">
                      <i className="ri-global-line text-xl text-[#D4AF37]"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900 mb-1">Wide Reach</div>
                      <div className="text-sm text-gray-600">Pan-African marketplace access</div>
                    </div>
                  </div>
                </div>
              </div>

              <button className="bg-gray-900 text-white px-8 py-4 rounded-full font-semibold hover:bg-gray-800 transition-all flex items-center gap-2 whitespace-nowrap">
                Explore Platform
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
